import { useState } from 'react';
import { MapProps } from '../components/Map/Map.types';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const useMapControls = () => {
  const [mapViewPort, setMapViewPort] = useState<{ center: google.maps.LatLngLiteral; bounds: google.maps.LatLngBounds }>();
  const [reCenterMap, setReCenterMap] = useState<MapProps['reCenterMap']>({ location: false, markers: false });

  const recenterMapViaMarkers = useEventCallback(() => {
    setReCenterMap(prev => ({ ...prev, markers: true }));
  });

  const recenterMapViaLocation = useEventCallback((isDefaultZoom?: boolean) => {
    setReCenterMap(prev => ({ ...prev, location: true, isDefaultZoom }));
  });

  const resetReCenterConfig = useEventCallback(() => {
    setReCenterMap({ location: false, markers: false });
  });

  const resetLocationRecenterConfig = useEventCallback(() => {
    setReCenterMap(prev => ({ ...prev, location: false }));
  });

  return {
    mapViewPort,
    setMapViewPort,

    setReCenterMap,
    reCenterMap,
    recenterMapViaMarkers,
    recenterMapViaLocation,
    resetLocationRecenterConfig,
    resetReCenterConfig,
  };
};
